import React from 'react';
import { CheckCircle, Circle, SkipForward, Star } from 'lucide-react';
import { QUESTION_RESPONSE_STATUS } from '../../../constants';

const Summary = (props) => {
  const { studentResponse } = props;

  const counts = {
    answered: 0,
    skipped: 0,
    bookmarked: 0,
    notVisited: 0
  };

  studentResponse.forEach((response) => {
    const { status, isBookmarked } = response;
    if (status === QUESTION_RESPONSE_STATUS.ANSWERED) counts.answered++;
    else if (status === QUESTION_RESPONSE_STATUS.SKIPPED) counts.skipped++;
    else if (status === QUESTION_RESPONSE_STATUS.NOT_VISITED) counts.notVisited++;
    if (isBookmarked) counts.bookmarked++;
  });

  const statusCards = [
    {
      key: 'answered',
      count: counts.answered,
      label: 'Answered',
      icon: CheckCircle,
      containerClass: 'bg-green-50 border-green-100',
      iconClass: 'text-green-600',
      countClass: 'text-green-700',
      labelClass: 'text-green-600'
    },
    {
      key: 'skipped',
      count: counts.skipped,
      label: 'Skipped',
      icon: SkipForward,
      containerClass: 'bg-orange-50 border-orange-100',
      iconClass: 'text-orange-500',
      countClass: 'text-orange-700',
      labelClass: 'text-orange-600'
    },
    {
      key: 'bookmarked',
      count: counts.bookmarked,
      label: 'Bookmarked',
      icon: Star,
      containerClass: 'bg-yellow-50 border-yellow-100',
      iconClass: 'text-yellow-500 fill-current',
      countClass: 'text-yellow-700',
      labelClass: 'text-yellow-600'
    },
    {
      key: 'notVisited',
      count: counts.notVisited,
      label: 'Not Visited',
      icon: Circle,
      containerClass: 'bg-gray-50 border-gray-200',
      iconClass: 'text-gray-400',
      countClass: 'text-gray-600',
      labelClass: 'text-gray-500'
    }
  ];

  return (
    <div className="mb-5 grid grid-cols-2 gap-2">
      {statusCards.map(
        ({ key, count, label, icon: Icon, containerClass, iconClass, countClass, labelClass }) => (
          <div
            key={key}
            className={`flex items-center gap-2 rounded-lg border px-3 py-2 ${containerClass}`}
          >
            <Icon className={`h-4 w-4 flex-shrink-0 ${iconClass}`} />
            <div>
              <p className={`text-sm font-semibold ${countClass}`}>{count}</p>
              <p className={`text-xs ${labelClass}`}>{label}</p>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export { Summary };
